






















import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder>
  },
  data() {
    return {
      active: false,
      req: {
        isPaid: false
      }
    };
  },
  methods: {
    click() {
      this.active = true;
    },
    async exec(cb: () => void) {
      if (!this.publishmentOrder) {
        return;
      }
      await this.$store.dispatch("patch", [
        this.publishmentOrder["@id"] + "/payment",
        this.req
      ]);
      this.$emit("success");
      cb();
    }
  }
});
